/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  IFlashLiquidationReceiver,
  IFlashLiquidationReceiverInterface,
} from "../IFlashLiquidationReceiver";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_user",
        type: "address",
      },
      {
        internalType: "address[]",
        name: "_assets",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_receivedCollaterals",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "_shareAmountsToRepaid",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "_flashReceiverData",
        type: "bytes",
      },
    ],
    name: "siloLiquidationCallback",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export class IFlashLiquidationReceiver__factory {
  static readonly abi = _abi;
  static createInterface(): IFlashLiquidationReceiverInterface {
    return new utils.Interface(_abi) as IFlashLiquidationReceiverInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IFlashLiquidationReceiver {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as IFlashLiquidationReceiver;
  }
}
